module.exports = __webpack_public_path__ + "img/organ_license.d7cffd46.png";